import { useEffect } from 'react';

// Identidade da plataforma — usada para compor títulos e metadados de SEO.
export const BRAND = 'CoreDesk';
export const SLOGAN = 'Venda e atenda em escala, com agentes de IA que nunca param';
const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://coredesk.com.br').replace(/\/$/, '');
const DEFAULT_DESCRIPTION =
  'CoreDesk é a plataforma de atendimento omnichannel com agentes de IA que vendem e atendem em escala, 24/7. WhatsApp, Instagram, e-mail e chatbot em um só lugar.';

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Define título e metatags de SEO por página (SPA sem SSR).
 * - Home: usa marca + slogan.
 * - Demais: "<title> | CoreDesk".
 */
const Seo = ({ title, description, path = '/', home = false }) => {
  useEffect(() => {
    const fullTitle = home || !title ? `${BRAND} — ${SLOGAN}` : `${title} | ${BRAND}`;
    const desc = description || DEFAULT_DESCRIPTION;
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    upsertMeta('name', 'description', desc);
    upsertLink('canonical', url);

    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', BRAND);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:url', url);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
  }, [title, description, path, home]);

  return null;
};

export default Seo;
